import React from 'react';
import { Badge } from '@chakra-ui/react';

const STATUS_CONFIG = {
  draft: { label: 'Draft', key: 'status.draft', scheme: 'gray' },
  open: { label: 'Open', key: 'status.open', scheme: 'blue' },
  has_quotes: { label: 'Has Quotes', key: 'status.has_quotes', scheme: 'purple' },
  accepted: { label: 'Accepted', key: 'status.accepted', scheme: 'purple' },
  awaiting_payment: { label: 'Awaiting Payment', key: 'status.awaiting_payment', scheme: 'yellow' },
  paid: { label: 'Paid', key: 'status.paid', scheme: 'green' },
  planned: { label: 'Planned', key: 'status.planned', scheme: 'cyan' },
  in_transit: { label: 'In Transit', key: 'status.in_transit', scheme: 'cyan' },
  pickedUp: { label: 'Picked Up', key: 'status.pickedUp', scheme: 'blue' },
  delivered: { label: 'Delivered', key: 'status.delivered', scheme: 'green' },
  completed: { label: 'Completed', key: 'status.completed', scheme: 'teal' },
  canceled: { label: 'Canceled', key: 'status.canceled', scheme: 'red' },
  expired: { label: 'Expired', key: 'status.expired', scheme: 'red' },
};

export default function StatusBadge({ status, translation, ...props }) {
  const config = STATUS_CONFIG[status] || {
    label: status || 'Unknown',
    scheme: 'gray',
  };

  // Prioritize translation key, fallback to label
  const textToTranslate = config.key || config.label;
  const label = translation ? translation(textToTranslate) : config.label;

  return (
    <Badge
      colorScheme={config.scheme}
      borderRadius="full"
      px={3}
      py={1}
      fontWeight="800"
      fontSize="11px"
      textTransform="uppercase"
      letterSpacing="0.05em"
      whiteSpace="normal"
      textAlign="center"
      lineHeight="1.2"
      {...props}
    >
      {label}
    </Badge>
  );
}
